import { render, staticRenderFns } from "./due-date-setup.vue?vue&type=template&id=0846a28c&"
import script from "./due-date-setup.vue?vue&type=script&lang=ts&"
export * from "./due-date-setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports